import _ from '@/common/helpers/index';
import FilterSet from '../filter-set';


/**
 * Returns json pointer items, split string by FilterSet delimiter
 *
 * @param {string} jsonPointer - pointer path, for example /a/b/c/d
 * @param {string} delimiter - FilterSet.delimiter "/" or "."
 *
 * @typedef {array} pointerItems
 * @returns {pointerItems}
 */
export const getJsonPointerItems = (jsonPointer,
    delimiter = FilterSet.delimiter) => {
    if (jsonPointer[0] === delimiter) {
        return jsonPointer.slice(1).split(delimiter);
    }
    return jsonPointer.split(delimiter);
};

/**
 * Returns label items array by pointer items.
 *
 * @param {pointerItems} pointerItems
 * @typedef {array} pointerLabelItems
 *
 * returns pointerLabelItems
 */
export const getPointerLabelItems = pointerItems => pointerItems.map(str => _.unCamelCase(str));

/**
 * Returns label by json pointer.
 *
 * @param {string} jsonPointer
 * @param {string} joinDelimiter
 * @returns {string}
 */
export default function labelFromJsonPointer(jsonPointer = '', joinDelimiter = ' ') {
    let delimiter;

    if (jsonPointer.includes('.')) {
        delimiter = '.';
    } else if (jsonPointer.includes('/')) {
        delimiter = '/';
    } else {
        // eslint-disable-next-line
        delimiter = FilterSet.delimiter;
    }

    const pointerItems = getJsonPointerItems(jsonPointer, delimiter);
    const labelItems = getPointerLabelItems(pointerItems);

    return labelItems.join(joinDelimiter);
}
